import { render } from "./horizondalbarsurvival.vue?vue&type=template&id=66ba4978&scoped=true"
import script from "./horizondalbarsurvival.vue?vue&type=script&lang=js"
export * from "./horizondalbarsurvival.vue?vue&type=script&lang=js"

import "./horizondalbarsurvival.vue?vue&type=style&index=0&id=66ba4978&lang=css"
import "./horizondalbarsurvival.vue?vue&type=style&index=1&id=66ba4978&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ba4978"]])

export default __exports__